import { Header, Segment } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../components/Flex/Flex";
import CoverImage from "../../../ui/components/CoverImage/CoverImage";
import truncateString from "../../../ui/utils/truncateString";

import useArticleTypeTranslations from "../../hooks/useArticleTypeTranslations";

export default function ArticleSegment({ article, extra, children, style, onClick, ...props }) {
	const articleTypeTranslations = useArticleTypeTranslations();

	return (
		<Segment onClick={onClick} style={{ cursor: onClick && "pointer", ...style }} {...props}>
			<Flex alignItems="center" justifyContent="flex-start">
				<div style={{ marginRight: "1em", height: 40, width: 40 }}>
					<CoverImage thumb rounded data={article} size={40} style={{ margin: "0 auto" }} />
				</div>

				<div>
					<Header as="h5" style={{ margin: 0 }}>
						{truncateString(article.name, 50)}
					</Header>

					<div style={{ opacity: 0.4, fontSize: "0.9em" }}>
						{articleTypeTranslations[article.type]} ({article.isbn})
					</div>
				</div>

				{extra && <div style={{ marginLeft: "auto" }}>{extra}</div>}
			</Flex>

			{children}
		</Segment>
	);
}
